'use strict';

var jsxRuntime = require('react/jsx-runtime');
var tailwindMerge = require('tailwind-merge');
require('../../../_virtual/_tslib.js');
var Box = require('../../Base/Layouts/Box/Box.js');
require('../../Base/Layouts/FullBleed/FullBleed.js');

const ModalContainer = ({ size = 'md', overflow = 'auto', children })=>{
    const overflowStyle = {
        auto: 'overflow-auto',
        visible: 'overflow-visible',
        hidden: 'overflow-hidden',
        scroll: 'overflow-scroll'
    };
    const sizeStyle = {
        xs: 'w-[320px]',
        sm: 'w-[400px]',
        md: 'w-[500px]',
        lg: 'w-[600px]',
        xl: 'w-[1000px]',
        full: 'w-full'
    };
    return jsxRuntime.jsx(Box, {
        "data-testid": "design-system--modal-container",
        className: tailwindMerge.twJoin('h-fit rounded-3xl bg-w-white shadow-modal', // 아직 정해지지 않은 내부 레이아웃
        'flex items-center justify-center', sizeStyle[size], overflowStyle[overflow]),
        children: children
    });
};

module.exports = ModalContainer;
